import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import Edit from '@material-ui/icons/Edit'
import TextField from "@material-ui/core/TextField";
import {Objects} from "../index";

export default class Refunds extends Framework.Components.Collection {
	constructor(props) {

		let model = new API.BuildClass(Types.Refunds._name, API.RequestType.READ_ALL);
		super(props,model);
		this.state.limit = 16;
	}
	render() {
		const {data, pages, limit, loading} = this.state;
		const columns=[
			{
				Header: "Customer",
				id: 'customers.name',
				style: { whiteSpace: "nowrap" }, // Prevent wrapping
				width: 250, // Set a minimum width
				/** @param {Refunds_Object} obj */
				accessor: obj => obj.customers?.name,
			},
			{
				Header: "Engineer",
				id: 'users_related_by_field_engineer.pkey',
				style: { whiteSpace: "nowrap" }, // Prevent wrapping
				width: 250, // Set a minimum width
				/** @param {Refunds_Object} obj */
				accessor: obj => (obj.users.name_first + ' ' + obj.users.name_last),
			},
			{
				Header: "Amount",
				id: 'amount',
				style: { whiteSpace: "nowrap" }, // Prevent wrapping
				width: 150, // Set a minimum width
				/** @param {Refunds_Object} obj */
				accessor: obj => obj.amount,
			},
			{
				Header: "Created",
				id: 'created',
				style: { whiteSpace: "nowrap" }, // Prevent wrapping
				width: 200, // Set a minimum width
				/** @param {Refunds_Object} obj */
				accessor: obj => (moment(obj.created).format('MM/DD/YYYY h:mm A')),
			},
			{
				Header: "Notes",
				id: 'notes',
				style: { whiteSpace: "unset", flex: 1 }, // Allow wrapping and let this column expand
				/** @param {Refunds_Object} obj */
				accessor: obj => obj.notes,
			},
			{
				Header: "",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 50,
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<span>
							<Link to={"/refunds/" + props.original.pkey}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},

		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Refunds')}
							{this.renderHeaderRight("Refunds", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
